import { AnimatePresence } from 'framer-motion';
import { DraggableBottomSheet } from '@/components/ui/DraggableBottomSheet';
import { ChatDemoScreen } from './ChatDemoScreen';

interface ChatDemoSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ChatDemoSheet({ open, onOpenChange }: ChatDemoSheetProps) {
  return (
    <AnimatePresence>
      {open && (
        <DraggableBottomSheet
          open={open}
          onOpenChange={onOpenChange}
          showCloseButton={true}
          height="85vh"
        >
        <div className="h-full overflow-y-auto overflow-x-hidden overscroll-contain touch-pan-y">
          <ChatDemoScreen onComplete={() => onOpenChange(false)} />
        </div>
        </DraggableBottomSheet>
      )}
    </AnimatePresence>
  );
}
